<template>
	<ion-popover
		ref="popover"
		:is-open="plantings?.length"
		reference="event"
		:event="event"
		:dismiss-on-select="true"
		:show-backdrop="false"
		:show-arrow="false"
		@ion-popover-did-dismiss="() => $emit('done')"
	>
		<ion-content v-if="plantings">
			<div
				class="w-full border-b-2 border-gray-200 px-4 py-2 text-center text-[1.05rem] font-bold"
			>
				{{ $t("main-map.plantings-selected") }}:
			</div>
			<div class="flex flex-col py-1">
				<div
					v-for="planting in _.sortBy(plantings, [
						'wetDateCurrent',
						'name',
					])"
					:key="planting.id"
					class="flex cursor-pointer flex-row justify-between gap-4 px-4 py-2 hover:bg-gray-200"
					@click="emit('select', planting.id)"
				>
					<div>
						{{ planting.name }}
					</div>
					<div>
						{{ formatDateString(planting.wetDateCurrent) }}
					</div>
				</div>
			</div>
		</ion-content>
	</ion-popover>
</template>

<script setup lang="ts">
	import { IonPopover, IonContent } from "@ionic/vue";
	import { PlantingDTO } from "seedgreen-shared/dtos/PlantingDTO";
	import { ref, watch } from "vue";
	import _ from "lodash";
	import { formatDateString } from "@/utils/date";

	const props = defineProps<{
		plantings?: PlantingDTO[];
		referenceElement: HTMLElement | null;
	}>();

	const event = ref({
		clientX: 0,
		clientY: 0,
	});

	watch(
		() => props.plantings,
		() => {
			if (!props.referenceElement) {
				return;
			}

			const rect = props.referenceElement.getBoundingClientRect();
			event.value = {
				clientX: rect.left + rect.width / 2,
				clientY: rect.top + rect.height / 2,
			};
		},
	);

	const emit = defineEmits<{
		done: [];
		select: [plantingId: number];
	}>();
</script>

<style scoped>
	ion-popover {
		--width: max-content;
	}
</style>
